import React from 'react';

const Calendar = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="2.60001"
      width="16"
      height="14.4"
      rx="2"
      stroke="#90949C"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12.5558 1V4.2"
      stroke="#90949C"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M5.44444 1V4.2"
      stroke="#90949C"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M1 7.4H17"
      stroke="#90949C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Calendar;
